class FileService {
    /**
     * Format bytes as human-readable text.
     * 
     * @param bytes Number of bytes.
     * @param si True to use metric (SI) units, aka powers of 1000. False to use 
     *           binary (IEC), aka powers of 1024.
     * @param dp Number of decimal places to display.
     * 
     * @return Formatted string.
     */
    fileSizeToHumanReadableFormat(bytes, si=false, dp=1) {
        const thresh = si ? 1000 : 1024;
    
        if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
        }
    
        const units = si 
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        let u = -1;
        const r = 10**dp;
    
        do {
        bytes /= thresh;
        ++u;
        } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
    
    
        return bytes.toFixed(dp) + ' ' + units[u];
    }

    millisecondsToHumanReadableFormat (milliseconds) {
        function numberEnding (number) {
            return (number > 1) ? 'n' : '';
        }

        var temp = Math.floor(milliseconds / 1000);
        var years = Math.floor(temp / 31536000);
        if (years) {
            return years + ' Jahre' + numberEnding(years);
        }

        var days = Math.floor((temp %= 31536000) / 86400);
        if (days) {
            return days + ' Tage' + numberEnding(days);
        }

        var hours = Math.floor((temp %= 86400) / 3600);
        if (hours) {
            return hours + ' Stunde' + numberEnding(hours);
        }

        var minutes = Math.floor((temp %= 3600) / 60);
        if (minutes) {
            return minutes + ' Minute' + numberEnding(minutes);
        }

        var seconds = temp % 60;
        if (seconds) {
            return seconds + ' Sekunde' + numberEnding(seconds);
        }
        return 'weniger als eine Sekunde';
    }
}

export default new FileService();